import { Middleware } from '@reduxjs/toolkit';
import { refreshaccess } from '../features/user/userSlice';
import { RootState } from '../store/store';

let isRefreshing = false;

export const tokenMiddleware: Middleware = (store) => (next) => async (action) => {
  const state: RootState = store.getState();
  const { access, refresh } = state.user;
  const expirationTime = getTokenExpiration(access);
  
  if (expirationTime && expirationTime < Date.now() && !isRefreshing) {
    isRefreshing = true;
    try {
      // Dispatch refreshaccess and wait for it to complete
      const result = await store.dispatch(refreshaccess(refresh) as any);
      // Check if refresh was successful
      if (refreshaccess.fulfilled.match(result)) {
        // Refresh token succeeded, continue
      } else {
        // Refresh token failed
        throw new Error('Refresh token failed');
      }
    } catch (error) {
      console.error('Error refreshing token', error);
      localStorage.clear();
      window.location.reload();
    } finally {
      isRefreshing = false;
    }
  }

  return next(action);
};

const getTokenExpiration = (token: string | null): number | null => {
  if (!token) return null;
  const [, payload] = token.split('.');
  const decodedPayload = JSON.parse(atob(payload));
  return decodedPayload.exp * 1000;
};
